exports = module.exports = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._2m9xKJf1hRzSAseLkCdQJ6{color:var(--card-neutralSecondary)}._1xeEx-RsI-LpZdwgcAgn1P{color:var(--card-dueDateRed)}._2REy6N-tcgkGq8oaaoL9og{color:var(--card-dueDateGreen)}", ""]);
// Exports
exports.locals = {
	"future": "_2m9xKJf1hRzSAseLkCdQJ6",
	"todayAndPast": "_1xeEx-RsI-LpZdwgcAgn1P",
	"completed": "_2REy6N-tcgkGq8oaaoL9og"
};